export default (state, getters, rootState) => (val) => {
    let ag = getters.item(val),
        form = rootState.finances.pay.form,
        requests;
    if (!ag) return [];
    requests = ag.requests.filter(i => {
        if(form.ContragentType===1||form.ContragentType===2){
            return i.type === form.ContragentType;
        }
        return i.contragent === form.ContragentID && i.type === form.ContragentType && i.legal === form.PartnerLegalEntityId;
    });
    return requests;
}